import { render } from "./DictCard.vue?vue&type=template&id=6480dca8&scoped=true"
import script from "./DictCard.vue?vue&type=script&lang=js"
export * from "./DictCard.vue?vue&type=script&lang=js"

import "./DictCard.vue?vue&type=style&index=0&id=6480dca8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6480dca8"]])

export default __exports__